import { FIELD_TYPES, PAGE_NAME } from '../../../shared/constants';

export const APP_NAME = PAGE_NAME.BUYER;

/**
 * The maximum amount a user can load more projects in listings
 * @type {Number}
 */
export const MAX_LOAD_MORE_ALLOWED = 5;

/**
 * The static listings impression enrichment
 */
export const LISTINGS_IMPRESSION_ENRICHMENT = {
    out_of_session: false,
    page: { name: 'logo_maker_listings' },
    feature: { name: 'logo_maker' },
};

export const USER_SAVING_ACTIONS = {
    ADD: 'add',
    REMOVE: 'remove',
};

export const PAGE_ELEMENT_TEXT_TYPES = {
    [FIELD_TYPES.BRAND_NAME]: 'name',
    [FIELD_TYPES.SLOGAN]: 'slogan',
};

export const LISTINGS_PAGE_BODY_CLASS = 'buyers-listings-page';

export const LISTING_ROUTE_SOURCE = 'listing';

export const GAMING_INDUSTRIES = ['gaming', 'gaming_channel_or_blog', 'gaming_streaming', 'gaming_store', 'gamer'];
